import { createCrudService } from '@/services/api/createCrudService'

export interface MaritalStatus {
  id: string
  maritalStatus: string
  description: string
  portoSeguroReport: string | null
  status: 'ATIVO' | 'INATIVO'
}

export const MaritalStatusesService = createCrudService<MaritalStatus>('/settings/marital-statuses', { searchField: 'description' })
